export default "__VITE_ASSET__2655c1f0__"